import { render } from "./index.vue?vue&type=template&id=346b881b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=346b881b&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-346b881b"

export default script